export function insertIf<T>(condition?: boolean, ...array: T[]): T[] | never[] {
  return condition ? array : [];
}
